import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import RenderIcon from '../../../commons/RenderIcon';

class SubmenuItem extends Component {
    render() {
        const { submenuItem: {label, icon}, onSubmenuClicked, active,customIcons } = this.props;
        return (
            <li className="nav-item">
                <Button color='link' className={`nav-link ${active ? 'active' : ''}`} onClick={onSubmenuClicked}>
                    <span className='text'>
                        {
                            icon && icon.cssClass ? <RenderIcon config={icon} customIcons={customIcons} /> : ''
                        }
                        {label}
                    </span>
                </Button>
            </li>
        );
    }
}

SubmenuItem.defaultProps = {
    active: false
}

SubmenuItem.propTypes = {
    submenuItem: PropTypes.object,
    onSubmenuClicked: PropTypes.func,
    active: PropTypes.bool
};

export default SubmenuItem;